import {
  Typography,
  AccordionSummary as MUIAccordionSummary,
  Accordion as MUIAccordion,
  AccordionDetails as MUIAccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Accordion = ({ subtitle, children, sx = {} }) => {
  const style = { width: '100%' };

  return (
    <MUIAccordion sx={{ ...sx, ...style }}>
      <MUIAccordionSummary
        sx={{
          '& .MuiAccordionSummary-content': {
            justifyContent: 'left',
          },
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography sx={{ fontWeight: 'bold' }}>{subtitle}</Typography>
      </MUIAccordionSummary>
      <MUIAccordionDetails>{children}</MUIAccordionDetails>
    </MUIAccordion>
  );
};

export default Accordion;
